import React from 'react';
import PickupSchedulingNotice from '../PickupSchedulingNotice';

export default function PickupStep({ state, setField }) {
    return (
        <div className="shipping-step">
            <h3>Pickup Address</h3>
            <div className="group">
                <label>Pickup Address</label>
                <input
                    type="text"
                    placeholder="eg: 123 Main St, City, State, ZIP"
                    value={state.pickupAddress || ''}
                    onChange={(e) => setField('pickupAddress', e.target.value)}
                />
                <p className="help">
                    Only city, state, and ZIP are shown to buyers before purchase.
                    Full address is revealed after payment.
                </p>
            </div>
            <PickupSchedulingNotice />
        </div>
    );
}
